import { HttpRequest } from '../../util/http';

export const sendPrompt = (input: string, content: any) => {
    const data = {
        question: input,
        file: content,
    }
    const method = 'POST';
    return HttpRequest.fetch('/web/v1/smart-summaries/question', { method, data })
}
